import React from "react";
import bgImg from "../Images/hero.jpeg";
import { FaUsers, FaHandshake } from "react-icons/fa";
import { FaPaperPlane, FaEye } from "react-icons/fa";
import image1 from'../Images/image1.jpeg'
import Header from "./Header";
import Footer from "./Footer";
import Navbar from "./Navbar";




const About = () => {
  return (
    <>
   
<Header/>
<Navbar/>

     
     <section
   className="container-fluid d-flex align-items-center justify-content-center text-center"
   style={{
     minHeight: "45vh",   
     backgroundImage: `linear-gradient(
       rgba(255, 201, 74, 0.88),
       rgba(255, 201, 74, 0.88)
     ), url(${bgImg})`,
     backgroundSize: "cover",
     backgroundPosition: "center",
   }}
 >
   <div className="container">
     <h1 className="fw-bold display-5 mb-3 text-dark">
       About-Us
     </h1>
 
     <p
       className="mx-auto text-dark"
       style={{ maxWidth: "720px", fontSize: "18px" }}
     >
       We value the opportunity to connect with our customers and answer
       any questions they may have.
     </p>
   </div>
 </section>
    <section className="py-5">
          <div className="container">
            <div className="row align-items-center">
    
              {/* LEFT IMAGE */}
              <div className="col-lg-6 position-relative mb-5 mb-lg-0">
                <img
                  src={image1}
                  className="img-fluid rounded-4 w-100"
                  alt="Pump Motor"
                />
              </div>
    
              {/* RIGHT CONTENT */}
              <div className="col-lg-6 ps-lg-5">
    
                {/* WHY CHOOSE US ARROW + TEXT */}
                <div className="d-flex align-items-center mb-2">
                  <span
                    style={{
                      width: "30px",
                      height: "3px",
                      backgroundColor: "#224b8f",
                      marginRight: "10px",
                    }}
                  ></span>
                  <span
                    className="fw-semibold"
                    style={{ color: "#224b8f" }}
                  >
                    WHY CHOOSE US?
                  </span>
                </div>
    
                <h2 className="fw-bold mb-3">
                  High-quality pumps and motors for every industrial and home need.
                </h2>
    
                <p className="text-muted mb-4">
                  We specialize in supplying reliable, energy-efficient pumps and
                  motors designed for long-lasting performance. Our products are
                  trusted by homeowners, businesses, and industries for consistent
                  and powerful results.
                </p>
    
                {/* FEATURE 1 */}
                <div className="d-flex mb-4">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center me-3"
                    style={{
                      width: "48px",
                      height: "48px",
                      backgroundColor: "#e8eef8",
                      color: "#224b8f",
                    }}
                  >
                    <FaUsers size={20} />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">
                      Wide Range of Pumps & Motors
                    </h5>
                    <p className="text-muted mb-0">
                      From domestic water pumps to heavy-duty industrial motors,
                      we offer solutions for every application.
                    </p>
                  </div>
                </div>
    
                {/* FEATURE 2 */}
                <div className="d-flex mb-4">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center me-3"
                    style={{
                      width: "48px",
                      height: "48px",
                      backgroundColor: "#e8eef8",
                      color: "#224b8f",
                    }}
                  >
                    <FaHandshake size={20} />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">
                      Trusted Quality & Expert Support
                    </h5>
                    <p className="text-muted mb-0">
                      We help you choose the right pump or motor with expert
                      guidance and dependable after-sales support.
                    </p>
                  </div>
                </div>
    
       
    
              </div>
            </div>
          </div>
        </section>


  <section className="py-5 bg-white">
  <div className="container">
    <div className="row g-4">

      {/* Our Mission */}
      <div className="col-md-6">
        <div className="p-5 h-100 text-center border rounded shadow-sm">
          <div className="mb-3">
            <span className="d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded p-3">
              <FaPaperPlane size={28} style={{ color: "#224b8f" }} />
            </span>
          </div>

          <h3
            className="fw-bold mb-3"
            style={{ color: "#224b8f" }}
          >
            Our Mission
          </h3>
<p className="text-muted">
  Our mission is to provide high-quality pumps and motors that exceed our clients' expectations. Through innovation and exceptional customer service, we strive to be the leading supplier in the industry. 
</p>

        </div>
      </div>

      {/* Our Vision */}
      <div className="col-md-6">
        <div className="p-5 h-100 text-center border rounded shadow-sm">
          <div className="mb-3">
            <span className="d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded p-3">
              <FaEye size={28} style={{ color: "#224b8f" }} />
            </span>
          </div>

          <h3
            className="fw-bold mb-3"
            style={{ color: "#224b8f" }}
          >
            Our Vision
          </h3>

        <p className="text-muted">
  Our vision is to be the most trusted supplier of high-quality pumps and motors, driving innovation and excellence to meet the evolving needs of our customers.
</p>

        </div>
      </div>

    </div>
  </div>
</section>


<Footer/>

    </>
  );
};

export default About;
